/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlChatOpsTimeoutVerdict = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlChatOpsTimeoutVerdict = typeof ControlChatOpsTimeoutVerdict[keyof typeof ControlChatOpsTimeoutVerdict];


export function ControlChatOpsTimeoutVerdictFromJSON(json: any): ControlChatOpsTimeoutVerdict {
    return ControlChatOpsTimeoutVerdictFromJSONTyped(json, false);
}

export function ControlChatOpsTimeoutVerdictFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlChatOpsTimeoutVerdict {
    return json as ControlChatOpsTimeoutVerdict;
}

export function ControlChatOpsTimeoutVerdictToJSON(value?: ControlChatOpsTimeoutVerdict | null): any {
    return value as any;
}

